import axios from "axios";
import { BASE_URL } from "../constants/baseUrl";
import API_ENDPOINTS, { getPredictionEndpoint } from "./apiendpoints";

const METHODS_WITH_BODY = new Set(["POST", "PUT", "PATCH", "DELETE"]);

const setAuthHeader = () => {
  const token = localStorage.getItem("token");
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

export const apiRequest = async (requestType = "GET", endpoint, body = {}) => {
  try {
    setAuthHeader();

    const method = typeof requestType === "string"
      ? requestType.toUpperCase()
      : "GET";

    const config = {
      method,
      url: `${BASE_URL}${endpoint}`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    if (METHODS_WITH_BODY.has(method)) {
      config.data = body;
    }

    const response = await axios(config);
    return response.data;
  } catch (error) {
    return { error: error.response?.data || "Failed to fetch data" };
  }
};

export const submitModelPrediction = async (modelKey, payload) => {
  const endpoint = getPredictionEndpoint(modelKey);
  if (!endpoint) {
    throw new Error(`Unsupported prediction model: ${modelKey}`);
  }

  const response = await apiRequest("POST", endpoint, payload);
  if (response?.error) {
    const message =
      typeof response.error === "string"
        ? response.error
        : response.error?.message || "Prediction request failed";
    throw new Error(message);
  }

  return response;
};

export const API_ROUTES = API_ENDPOINTS;
